/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ConfigurationIntegrationTypes } from '../models/configuration-integration-types';
import { configurationsIntegrationsGet } from '../fn/configurations/configurations-integrations-get';
import { ConfigurationsIntegrationsGet$Params } from '../fn/configurations/configurations-integrations-get';
import { configurationsIntegrationsIntegrationNameVersionsIntegrationVersionGet } from '../fn/configurations/configurations-integrations-integration-name-versions-integration-version-get';
import { ConfigurationsIntegrationsIntegrationNameVersionsIntegrationVersionGet$Params } from '../fn/configurations/configurations-integrations-integration-name-versions-integration-version-get';
import { defaultConfigsConfigIdGet } from '../fn/configurations/default-configs-config-id-get';
import { DefaultConfigsConfigIdGet$Params } from '../fn/configurations/default-configs-config-id-get';
import { defaultConfigsConfigIdPut } from '../fn/configurations/default-configs-config-id-put';
import { DefaultConfigsConfigIdPut$Params } from '../fn/configurations/default-configs-config-id-put';
import { getHubConfigurationsDownloadUrl } from '../fn/configurations/get-hub-configurations-download-url';
import { GetHubConfigurationsDownloadUrl$Params } from '../fn/configurations/get-hub-configurations-download-url';
import { IntegrationConfiguration } from '../models/integration-configuration';
import { PosIntegrationConfigurationPaginated } from '../models/pos-integration-configuration-paginated';
import { posIntegrationConfigurationsGet } from '../fn/configurations/pos-integration-configurations-get';
import { PosIntegrationConfigurationsGet$Params } from '../fn/configurations/pos-integration-configurations-get';
import { posIntegrationConfigurationsProvidersPosProviderTypeIdIdGet } from '../fn/configurations/pos-integration-configurations-providers-pos-provider-type-id-id-get';
import { PosIntegrationConfigurationsProvidersPosProviderTypeIdIdGet$Params } from '../fn/configurations/pos-integration-configurations-providers-pos-provider-type-id-id-get';
import { posIntegrationConfigurationsProvidersPosProviderTypeIdIdVersionIdVersionIdGet } from '../fn/configurations/pos-integration-configurations-providers-pos-provider-type-id-id-version-id-version-id-get';
import { PosIntegrationConfigurationsProvidersPosProviderTypeIdIdVersionIdVersionIdGet$Params } from '../fn/configurations/pos-integration-configurations-providers-pos-provider-type-id-id-version-id-version-id-get';
import { PutResponse } from '../models/put-response';
import { TenantPosConfig } from '../models/tenant-pos-config';
import { TenantPosConfigs } from '../models/tenant-pos-configs';
import { tenantsTenantIdDefaultConfigsGet } from '../fn/configurations/tenants-tenant-id-default-configs-get';
import { TenantsTenantIdDefaultConfigsGet$Params } from '../fn/configurations/tenants-tenant-id-default-configs-get';
import { tenantsTenantIdDefaultConfigsPost } from '../fn/configurations/tenants-tenant-id-default-configs-post';
import { TenantsTenantIdDefaultConfigsPost$Params } from '../fn/configurations/tenants-tenant-id-default-configs-post';

@Injectable({ providedIn: 'root' })
export class ConfigurationsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `defaultConfigsConfigIdGet()` */
  static readonly DefaultConfigsConfigIdGetPath = '/default-configs/{configId}';

  /**
   * Gets a specified Tenant POS Config.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `defaultConfigsConfigIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  defaultConfigsConfigIdGet$Response(params: DefaultConfigsConfigIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<TenantPosConfig>> {
    return defaultConfigsConfigIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets a specified Tenant POS Config.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `defaultConfigsConfigIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  defaultConfigsConfigIdGet(params: DefaultConfigsConfigIdGet$Params, context?: HttpContext): Observable<TenantPosConfig> {
    return this.defaultConfigsConfigIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<TenantPosConfig>): TenantPosConfig => r.body)
    );
  }

  /** Path part for operation `defaultConfigsConfigIdPut()` */
  static readonly DefaultConfigsConfigIdPutPath = '/default-configs/{configId}';

  /**
   * Updates a specified Tenant POS Config.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `defaultConfigsConfigIdPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  defaultConfigsConfigIdPut$Response(params: DefaultConfigsConfigIdPut$Params, context?: HttpContext): Observable<StrictHttpResponse<PutResponse>> {
    return defaultConfigsConfigIdPut(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates a specified Tenant POS Config.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `defaultConfigsConfigIdPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  defaultConfigsConfigIdPut(params: DefaultConfigsConfigIdPut$Params, context?: HttpContext): Observable<PutResponse> {
    return this.defaultConfigsConfigIdPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<PutResponse>): PutResponse => r.body)
    );
  }

  /** Path part for operation `tenantsTenantIdDefaultConfigsGet()` */
  static readonly TenantsTenantIdDefaultConfigsGetPath = '/tenants/{tenantId}/default-configs';

  /**
   * Gets all POS Configs by tenant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantsTenantIdDefaultConfigsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantsTenantIdDefaultConfigsGet$Response(params: TenantsTenantIdDefaultConfigsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<TenantPosConfigs>> {
    return tenantsTenantIdDefaultConfigsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets all POS Configs by tenant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantsTenantIdDefaultConfigsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantsTenantIdDefaultConfigsGet(params: TenantsTenantIdDefaultConfigsGet$Params, context?: HttpContext): Observable<TenantPosConfigs> {
    return this.tenantsTenantIdDefaultConfigsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<TenantPosConfigs>): TenantPosConfigs => r.body)
    );
  }

  /** Path part for operation `tenantsTenantIdDefaultConfigsPost()` */
  static readonly TenantsTenantIdDefaultConfigsPostPath = '/tenants/{tenantId}/default-configs';

  /**
   * Create a POS config  for this tenant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantsTenantIdDefaultConfigsPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tenantsTenantIdDefaultConfigsPost$Response(params: TenantsTenantIdDefaultConfigsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<TenantPosConfig>> {
    return tenantsTenantIdDefaultConfigsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a POS config  for this tenant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantsTenantIdDefaultConfigsPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tenantsTenantIdDefaultConfigsPost(params: TenantsTenantIdDefaultConfigsPost$Params, context?: HttpContext): Observable<TenantPosConfig> {
    return this.tenantsTenantIdDefaultConfigsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<TenantPosConfig>): TenantPosConfig => r.body)
    );
  }

  /** Path part for operation `posIntegrationConfigurationsGet()` */
  static readonly PosIntegrationConfigurationsGetPath = '/pos-integration-configurations';

  /**
   * Returns a list of POS integration Configurations from all POS integration providers.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `posIntegrationConfigurationsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  posIntegrationConfigurationsGet$Response(params?: PosIntegrationConfigurationsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<PosIntegrationConfigurationPaginated>> {
    return posIntegrationConfigurationsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Returns a list of POS integration Configurations from all POS integration providers.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `posIntegrationConfigurationsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  posIntegrationConfigurationsGet(params?: PosIntegrationConfigurationsGet$Params, context?: HttpContext): Observable<PosIntegrationConfigurationPaginated> {
    return this.posIntegrationConfigurationsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<PosIntegrationConfigurationPaginated>): PosIntegrationConfigurationPaginated => r.body)
    );
  }

  /** Path part for operation `posIntegrationConfigurationsProvidersPosProviderTypeIdIdGet()` */
  static readonly PosIntegrationConfigurationsProvidersPosProviderTypeIdIdGetPath = '/pos-integration-configurations/providers/{posProviderType}/id/{id}';

  /**
   * Returns a json form for one POS Integration Configurations.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `posIntegrationConfigurationsProvidersPosProviderTypeIdIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  posIntegrationConfigurationsProvidersPosProviderTypeIdIdGet$Response(params: PosIntegrationConfigurationsProvidersPosProviderTypeIdIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<IntegrationConfiguration>> {
    return posIntegrationConfigurationsProvidersPosProviderTypeIdIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Returns a json form for one POS Integration Configurations.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `posIntegrationConfigurationsProvidersPosProviderTypeIdIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  posIntegrationConfigurationsProvidersPosProviderTypeIdIdGet(params: PosIntegrationConfigurationsProvidersPosProviderTypeIdIdGet$Params, context?: HttpContext): Observable<IntegrationConfiguration> {
    return this.posIntegrationConfigurationsProvidersPosProviderTypeIdIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<IntegrationConfiguration>): IntegrationConfiguration => r.body)
    );
  }

  /** Path part for operation `posIntegrationConfigurationsProvidersPosProviderTypeIdIdVersionIdVersionIdGet()` */
  static readonly PosIntegrationConfigurationsProvidersPosProviderTypeIdIdVersionIdVersionIdGetPath = '/pos-integration-configurations/providers/{posProviderType}/id/{id}/versionId/{versionId}';

  /**
   * Returns a json form for one POS integration configurations.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `posIntegrationConfigurationsProvidersPosProviderTypeIdIdVersionIdVersionIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  posIntegrationConfigurationsProvidersPosProviderTypeIdIdVersionIdVersionIdGet$Response(params: PosIntegrationConfigurationsProvidersPosProviderTypeIdIdVersionIdVersionIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<IntegrationConfiguration>> {
    return posIntegrationConfigurationsProvidersPosProviderTypeIdIdVersionIdVersionIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Returns a json form for one POS integration configurations.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `posIntegrationConfigurationsProvidersPosProviderTypeIdIdVersionIdVersionIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  posIntegrationConfigurationsProvidersPosProviderTypeIdIdVersionIdVersionIdGet(params: PosIntegrationConfigurationsProvidersPosProviderTypeIdIdVersionIdVersionIdGet$Params, context?: HttpContext): Observable<IntegrationConfiguration> {
    return this.posIntegrationConfigurationsProvidersPosProviderTypeIdIdVersionIdVersionIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<IntegrationConfiguration>): IntegrationConfiguration => r.body)
    );
  }

  /** Path part for operation `getHubConfigurationsDownloadUrl()` */
  static readonly GetHubConfigurationsDownloadUrlPath = '/pos-integration-configurations/adapter-download-url';

  /**
   * Gets an URL to download all hub configs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getHubConfigurationsDownloadUrl()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHubConfigurationsDownloadUrl$Response(params: GetHubConfigurationsDownloadUrl$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return getHubConfigurationsDownloadUrl(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets an URL to download all hub configs.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getHubConfigurationsDownloadUrl$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHubConfigurationsDownloadUrl(params: GetHubConfigurationsDownloadUrl$Params, context?: HttpContext): Observable<string> {
    return this.getHubConfigurationsDownloadUrl$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `configurationsIntegrationsGet()` */
  static readonly ConfigurationsIntegrationsGetPath = '/configurations/integrations';

  /**
   * Returns a list of Integration Types and Versions used on Integration Configuration templates.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `configurationsIntegrationsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  configurationsIntegrationsGet$Response(params?: ConfigurationsIntegrationsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<ConfigurationIntegrationTypes>> {
    return configurationsIntegrationsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Returns a list of Integration Types and Versions used on Integration Configuration templates.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `configurationsIntegrationsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  configurationsIntegrationsGet(params?: ConfigurationsIntegrationsGet$Params, context?: HttpContext): Observable<ConfigurationIntegrationTypes> {
    return this.configurationsIntegrationsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<ConfigurationIntegrationTypes>): ConfigurationIntegrationTypes => r.body)
    );
  }

  /** Path part for operation `configurationsIntegrationsIntegrationNameVersionsIntegrationVersionGet()` */
  static readonly ConfigurationsIntegrationsIntegrationNameVersionsIntegrationVersionGetPath = '/configurations/integrations/{integrationName}/versions/{integrationVersion}';

  /**
   * Get the Integration Configuration properties for a given Integration Type and Version.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `configurationsIntegrationsIntegrationNameVersionsIntegrationVersionGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  configurationsIntegrationsIntegrationNameVersionsIntegrationVersionGet$Response(params: ConfigurationsIntegrationsIntegrationNameVersionsIntegrationVersionGet$Params, context?: HttpContext): Observable<StrictHttpResponse<IntegrationConfiguration>> {
    return configurationsIntegrationsIntegrationNameVersionsIntegrationVersionGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the Integration Configuration properties for a given Integration Type and Version.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `configurationsIntegrationsIntegrationNameVersionsIntegrationVersionGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  configurationsIntegrationsIntegrationNameVersionsIntegrationVersionGet(params: ConfigurationsIntegrationsIntegrationNameVersionsIntegrationVersionGet$Params, context?: HttpContext): Observable<IntegrationConfiguration> {
    return this.configurationsIntegrationsIntegrationNameVersionsIntegrationVersionGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<IntegrationConfiguration>): IntegrationConfiguration => r.body)
    );
  }

}
